import { Grid, IconButton, List, ListItem, ListItemIcon, ListItemText, Popover } from "@material-ui/core"
import { MoreVert as MoreVertIcon } from "@material-ui/icons"
import React from "react"
import useStyles from "@/components/MoreOptionsMenu/styles"
import ChannelRestrictionGate from "@/components/ChannelRestrictionGate"
import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

export type MoreOptionsMenuOptionData = {
	title: string
	icon?: JSX.Element
	showIcon?: boolean
	hideOption?: boolean
	disabled?: boolean
	disabledTooltip?: string
	color?: "danger"
	onClick?: () => Promise<void> | void
}

export interface MoreOptionsMenuProps {
	options: MoreOptionsMenuOptionData[]
	iconSize?: "small" | "medium"
	enableBackground?: boolean
	closeOnClick?: boolean
	disabled?: boolean
}

const MoreOptionsMenu = (props: MoreOptionsMenuProps) => {
	const [moreOptionsMenuAnchorEl, setMoreOptionsMenuAnchorEl] = React.useState<null | HTMLElement>(null)
	const moreOptionsMenuIsOpen = Boolean(moreOptionsMenuAnchorEl)

	const { options, iconSize, enableBackground, closeOnClick, disabled } = props

	const classes = useStyles()

	const handleMoreOptionsMenuClose = () => {
		setMoreOptionsMenuAnchorEl(null)
	}

	const handleMoreOptionsMenuClick = (event: React.MouseEvent<HTMLElement>) => {
		if (disabled) {
			return
		}

		setMoreOptionsMenuAnchorEl(event.currentTarget)
	}

	const customStyleByColor = {
		danger: classes.danger
	}

	const visibleOptions = options.filter((option) => !option.hideOption)

	return <>
		<IconButton
			aria-label="more"
			aria-controls="long-menu"
			aria-haspopup="true"
			size={iconSize || "medium"}
			className={classes.iconButton}
			style={enableBackground ? {
				borderRadius: 3,
				...ColorUtil.getBackgroundAndContrastColor(colors.gray[100])
			} : undefined}
			disabled={disabled}
			onClick={handleMoreOptionsMenuClick}
		>
			<MoreVertIcon />
		</IconButton>
		<Popover
			open={moreOptionsMenuIsOpen}
			anchorEl={moreOptionsMenuAnchorEl}
			onClose={handleMoreOptionsMenuClose}
			anchorOrigin={{ vertical: "top", horizontal: "left" }}
			transformOrigin={{ vertical: "top", horizontal: "left" }}
		>
			<List>
				{visibleOptions.map((option, index) => (
					<Grid key={`${index}-${new Date()}`} justifyContent="center" alignItems="center" style={{ display: "flex" }}>
						<ChannelRestrictionGate
							variant="with-icon"
							otherRulesToDisabled={option.disabled ?? false}
							tooltipConfig={{ tooltipText: option.disabledTooltip }}
						>
							<ListItem
								button
								disabled={option.disabled}
								onClick={() => {
									if (option.disabled) {
										return
									}
									if (closeOnClick) {
										handleMoreOptionsMenuClose()
									}
									option?.onClick?.()
								}}
								key={option.title}
							>
								{
									option.showIcon && <ListItemIcon
										style={{ minWidth: "30px" }}
										className={option.color && customStyleByColor[option.color]}>
										{option.icon}
									</ListItemIcon>
								}
								<ListItemText
									primary={option.title}
									classes={{
										primary: option.color && customStyleByColor[option.color]
									}}
								/>
							</ListItem>
						</ChannelRestrictionGate>
					</Grid>
				))}
			</List>
		</Popover>
	</>
}

export default MoreOptionsMenu
